import _taggedTemplateLiteral from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CoreHelperUtil, RouterController } from '@web3modal/core';
import { customElement } from '@web3modal/ui';
import { LitElement, html } from 'lit';
let W3mDownloadsView = class W3mDownloadsView extends LitElement {
  constructor() {
    var _RouterController$sta;
    super(...arguments);
    this.wallet = (_RouterController$sta = RouterController.state.data) === null || _RouterController$sta === void 0 ? void 0 : _RouterController$sta.wallet;
  }
  render() {
    if (!this.wallet) {
      throw new Error('w3m-downloads-view');
    }
    return html(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      <wui-flex gap=\"xs\" flexDirection=\"column\" .padding=", ">\n        ", " ", " ", "\n        ", "\n      </wui-flex>\n    "])), ['s', 's', 'l', 's'], this.chromeTemplate(), this.iosTemplate(), this.androidTemplate(), this.homepageTemplate());
  }
  chromeTemplate() {
    var _this$wallet;
    if (!((_this$wallet = this.wallet) !== null && _this$wallet !== void 0 && _this$wallet.chrome_store)) {
      return null;
    }
    return html(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["<wui-list-item\n      variant=\"icon\"\n      icon=\"chromeStore\"\n      iconVariant=\"square\"\n      @click=", "\n      chevron\n    >\n      <wui-text variant=\"paragraph-500\" color=\"fg-100\">Chrome Extension</wui-text>\n    </wui-list-item>"])), this.onChromeStore.bind(this));
  }
  iosTemplate() {
    var _this$wallet2;
    if (!((_this$wallet2 = this.wallet) !== null && _this$wallet2 !== void 0 && _this$wallet2.app_store)) {
      return null;
    }
    return html(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["<wui-list-item\n      variant=\"icon\"\n      icon=\"appStore\"\n      iconVariant=\"square\"\n      @click=", "\n      chevron\n    >\n      <wui-text variant=\"paragraph-500\" color=\"fg-100\">iOS App</wui-text>\n    </wui-list-item>"])), this.onAppStore.bind(this));
  }
  androidTemplate() {
    var _this$wallet3;
    if (!((_this$wallet3 = this.wallet) !== null && _this$wallet3 !== void 0 && _this$wallet3.play_store)) {
      return null;
    }
    return html(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["<wui-list-item\n      variant=\"icon\"\n      icon=\"playStore\"\n      iconVariant=\"square\"\n      @click=", "\n      chevron\n    >\n      <wui-text variant=\"paragraph-500\" color=\"fg-100\">Android App</wui-text>\n    </wui-list-item>"])), this.onPlayStore.bind(this));
  }
  homepageTemplate() {
    var _this$wallet4;
    if (!((_this$wallet4 = this.wallet) !== null && _this$wallet4 !== void 0 && _this$wallet4.homepage)) {
      return null;
    }
    return html(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      <wui-list-item\n        variant=\"icon\"\n        icon=\"browser\"\n        iconVariant=\"square-blue\"\n        @click=", "\n        chevron\n      >\n        <wui-text variant=\"paragraph-500\" color=\"fg-100\">Website</wui-text>\n      </wui-list-item>\n    "])), this.onHomePage.bind(this));
  }
  onChromeStore() {
    var _this$wallet5;
    if ((_this$wallet5 = this.wallet) !== null && _this$wallet5 !== void 0 && _this$wallet5.chrome_store) {
      CoreHelperUtil.openHref(this.wallet.chrome_store, '_blank');
    }
  }
  onAppStore() {
    var _this$wallet6;
    if ((_this$wallet6 = this.wallet) !== null && _this$wallet6 !== void 0 && _this$wallet6.app_store) {
      CoreHelperUtil.openHref(this.wallet.app_store, '_blank');
    }
  }
  onPlayStore() {
    var _this$wallet7;
    if ((_this$wallet7 = this.wallet) !== null && _this$wallet7 !== void 0 && _this$wallet7.play_store) {
      CoreHelperUtil.openHref(this.wallet.play_store, '_blank');
    }
  }
  onHomePage() {
    var _this$wallet8;
    if ((_this$wallet8 = this.wallet) !== null && _this$wallet8 !== void 0 && _this$wallet8.homepage) {
      CoreHelperUtil.openHref(this.wallet.homepage, '_blank');
    }
  }
};
W3mDownloadsView = __decorate([customElement('w3m-downloads-view')], W3mDownloadsView);
export { W3mDownloadsView };
//# sourceMappingURL=index.js.map